<template>
    <div class="account-summary text-md-left">
        <p class="acc-summary-title" data-testid="lblHeaderAccSummary">Account Summary</p>
        <el-form :model="formAccSummary" label-width="250px" label-position="left">
            <el-row>
                <el-col :span="20">
                    <el-form-item>
                        <template #label>
                            <label data-testid="lblPackage">Package</label>
                        </template>
                        <el-select
                            v-model="subscriptionData.packageCode"
                            data-testid="ddlPackage"
                            placeholder="Select"
                            class="form-input"
                            :disabled="true"
                            @change="onChangePackage">
                            <el-option
                                v-for="item in formAccSummary.packageOptions"
                                :data-testid="`conPackage${item.label}`"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item>
                        <template #label>
                            <label data-testid="lblAccStatus">Account Status</label>
                        </template>
                        <el-select
                            v-model="subscriptionData.accountStatus"
                            data-testid="ddlAccStatus"
                            placeholder="Select"
                            :disabled="true"
                            class="form-input">
                            <el-option
                                v-for="item in formAccSummary.accStatusOptions"
                                :data-testid="`conAcc${item.label}`"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider class="divider-dash"></el-divider>
            <el-row>
                <el-col :span="24">
                    <p data-testid="lblAccLevel" class="acc-level-title">Account Level</p>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item>
                        <template #label>
                            <label data-testid="lblBuLevel">Business Level</label>
                        </template>
                        <el-col :span="12">
                            <el-input
                                v-model="subscriptionData.businessLevelAvg"
                                data-testid="txtBuLevelAvr"
                                readonly
                                class="form-input business-level-average readonly">
                            </el-input>
                            <span data-testid="lblDescriAvr" class="average-cycle">Average Last 3 Cycle</span>
                        </el-col>
                        <el-col :span="12">
                            <el-input
                                v-model="subscriptionData.businessLevelLast"
                                data-testid="txtBuLevelLastCycle"
                                readonly
                                class="form-input business-level-last readonly">
                            </el-input>
                            <span data-testid="lblDescriLastCycle" class="last-cycle">Last Cycle</span>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item>
                        <template #label>
                            <label data-testid="lblRegisDate">Registration Date</label>
                        </template>
                        <el-input
                            :value="subscriptionData.registrationDate ? $dayjs(subscriptionData.registrationDate).format('YYYY-MM-DD HH:mm:ss') : ''"
                            data-testid="txtRegisDate"
                            readonly
                            class="form-input readonly">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item>
                        <template #label>
                            <label data-testid="lblApproveDate">Approve Date</label>
                        </template>
                        <el-input
                            :value="subscriptionData.approveDate ? $dayjs(subscriptionData.approveDate).format('YYYY-MM-DD HH:mm:ss') : ''"
                            data-testid="txtApproveDate"
                            readonly
                            class="form-input readonly">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item>
                        <template #label>
                            <label data-testid="lblSubscriptionType">Subscription Plan</label>
                        </template>
                        <el-col :span="12" style="padding-right: 10px;">
                            <el-radio
                                v-model="subscriptionData.subscriptionDetail.type"
                                data-testid="rdoMonthly"
                                label="M"
                                border
                                :disabled="isSelectSubTypeAnnual"
                                class="form-input subscriptionDetail-radio monthly">
                                Monthly
                            </el-radio>
                        </el-col>
                        <el-col :span="12" style="padding-left: 10px;">
                            <el-radio
                                v-model="subscriptionData.subscriptionDetail.type"
                                data-testid="rdoAnnual"
                                label="A"
                                border
                                :disabled="!isSelectSubTypeAnnual"
                                class="form-input subscriptionDetail-radio annual">
                                Annual
                            </el-radio>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
            <div v-if="isSelectSubTypeAnnual">
                <el-row>
                    <el-col :span="20">
                        <el-form-item class="labelForm">
                            <div data-testid="conRdoType" class="subscription-plan-container" :class="btnSubscriptionPlan.isValid ? 'border':''">
                                <el-row>
                                    <el-col :span="12">
                                        <span>Plan Annual (Month)</span>
                                    </el-col>
                                    <el-col :span="12">
                                        <!-- <el-button
                                            type="primary"
                                            data-testid="btnMinus"
                                            icon="el-icon-minus"
                                            class="btn-minus"
                                            :disabled="onLessthanMonth"
                                            @click="onMinusMonth"></el-button> -->
                                        <el-input
                                            v-model="subscriptionData.subscriptionDetail.cycle"
                                            data-testid="txtBillCycle"
                                            class="form-input-cycle"
                                            readonly>
                                        </el-input>
                                        <!-- <el-button
                                            type="primary"
                                            data-testid="btmPlus"
                                            icon="el-icon-plus"
                                            class="btn-plus"
                                            @click="onPlusMonth"></el-button> -->
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <span data-testid="lblAnnualStartDate">Start Date</span>
                                        <el-input
                                            :value="subscriptionData.subscriptionDetail.startDate ? $dayjs(subscriptionData.subscriptionDetail.startDate).format('YYYY-MM-DD') : ''"
                                            data-testid="txtAnnualStartDate"
                                            readonly
                                            class="form-input readonly">
                                        </el-input>
                                    </el-col>
                                    <el-col :span="12">
                                        <span data-testid="lblAnnualEndDate">End Date</span>
                                        <el-input
                                            :value="subscriptionData.subscriptionDetail.endDate ? $dayjs(subscriptionData.subscriptionDetail.endDate).format('YYYY-MM-DD') : ''"
                                            data-testid="txtAnnualEndDate"
                                            readonly
                                            class="form-input readonly">
                                        </el-input>
                                    </el-col>
                                </el-row>
                            </div>
                            <span
                                v-if="btnSubscriptionPlan.isValid"
                                data-testid="lblErrorConfirmChange"
                                class="edit-annual-valid-message">
                                {{ cycleErrorMessage ? cycleErrorMessage : 'Please calculate the change of information.'}}
                                <!-- Please confirm the change of information. -->
                            </span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="16">
                        <el-form-item class="labelForm">
                            <!-- <el-button
                                type="primary"
                                data-testid="btnSubmitAnnual"
                                :disabled="btnSubscriptionPlan.isSubmit"
                                @click="onSubmitAnnualMonth">

                                    Calculate
                                </el-button> -->
                            <!-- <el-button
                                @click="onCancelAnnualMonth"
                                data-testid="btnCancelAnnual"
                                :disabled="btnSubscriptionPlan.isCancel">
                                    Cancel
                            </el-button> -->
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
        <el-divider></el-divider>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'AccountSummary',
    components: {},
    props: {
        subscriptionData: {
            type: Object,
            default: () => {}
        },
        userId: {
            type: String,
            default: ''
        },
        customerType: {
            type: String,
            default: ''
        },
        btnSubscriptionPlan: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            formAccSummary: {
                packageOptions: [
                    { value: 'BRO', label: 'Bronze' },
                    { value: 'SIL', label: 'Silver' },
                    { value: 'GOL', label: 'Gold' },
                    { value: 'PLA', label: 'Platinum' }
                ],
                accStatusOptions: [
                    { value: 1, label: 'Review' },
                    { value: 2, label: 'Active' },
                    { value: 3, label: 'Suspend' },
                    { value: 4, label: 'Inactive' }
                ],
                initialCycle: '',
                initialDate: {
                    startDate: '',
                    endDate: ''
                },
                cycleErrorMessage: ''
            }
        }
    },
    created () {
        this.initialCycle = this.subscriptionData.subscriptionDetail.cycle
        this.initialDate = {
            startDate: this.subscriptionData.subscriptionDetail.startDate,
            endDate: this.subscriptionData.subscriptionDetail.endDate
        }
    },
    watch: {
        'subscriptionData.subscriptionDetail.type' (value) {
            if (value === 'M') {
                this.subscriptionData.subscriptionDetail.cycle = this.initialCycle ? this.initialCycle : 12
                this.btnSubscriptionPlan.isSubmit = true
                this.btnSubscriptionPlan.isCancel = true
                this.btnSubscriptionPlan.isValid = false
                this.cycleErrorMessage = ''
            } else if (value === 'A') {
                if (this.subscriptionData.subscriptionDetail.cycle === 1) {
                    this.subscriptionData.subscriptionDetail.cycle = 12
                    this.subscriptionData.subscriptionDetail.startDate = this.initialDate.startDate
                    this.subscriptionData.subscriptionDetail.endDate = this.initialDate.endDate

                    this.btnSubscriptionPlan.isSubmit = false
                    this.btnSubscriptionPlan.isCancel = false
                    this.cycleErrorMessage = ''
                }
            }
        }
    },
    computed: {
        isCustomerType () {
            if (this.customerType === 'customer') {
                return false
            } return true
        },
        isPackage () {
            if (this.subscriptionData.packageCode === 'BRO') {
                return true
            } return false
        },
        isSelectSubTypeAnnual () {
            if (this.subscriptionData.subscriptionDetail.type === 'A') {
                return true
            } return false
        },
        onLessthanMonth () {
            if (this.subscriptionData.subscriptionDetail.cycle === 1) {
                return true
            } return false
        }
    },
    methods: {
        onChangePackage () {
            if (this.subscriptionData.packageCode === 'BRO') {
                this.subscriptionData.subscriptionDetail.type = 'M'
                this.cycleErrorMessage = ''
            }
        },
        async onSubmitAnnualMonth () {
            try {
                let param = {
                    userId: this.userId,
                    cycle: this.subscriptionData.subscriptionDetail.cycle
                }

                this.btnSubscriptionPlan.isSubmit = true
                this.btnSubscriptionPlan.isCancel = true
                this.btnSubscriptionPlan.isValid = false

                let res = await fgApi.subscription.getValidateSubscription(param)
                this.subscriptionData.subscriptionDetail.startDate = res.data.startDate ? res.data.startDate : ''
                this.subscriptionData.subscriptionDetail.endDate = res.data.endDate ? res.data.endDate : ''
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: 'รอบ Cycle ไม่ถูกต้อง'
                })

                this.btnSubscriptionPlan.isSubmit = false
                this.btnSubscriptionPlan.isCancel = false
                this.btnSubscriptionPlan.isValid = true
                this.cycleErrorMessage = 'ข้อมูลการคำนวณรอบ Plan Annual น้อยกว่าวันที่ปัจจุบัน'
            }
        },
        onCancelAnnualMonth () {
            this.subscriptionData.subscriptionDetail.cycle = this.initialCycle
            this.subscriptionData.subscriptionDetail.startDate = this.initialDate.startDate
            this.subscriptionData.subscriptionDetail.endDate = this.initialDate.endDate

            this.btnSubscriptionPlan.isSubmit = true
            this.btnSubscriptionPlan.isCancel = true
            this.btnSubscriptionPlan.isValid = false
            this.cycleErrorMessage = ''
        },
        onMinusMonth () {
            this.subscriptionData.subscriptionDetail.cycle--
            this.btnSubscriptionPlan.isSubmit = false
            this.btnSubscriptionPlan.isCancel = false
            this.btnSubscriptionPlan.isValid = false
            this.cycleErrorMessage = ''
        },
        onPlusMonth () {
            this.subscriptionData.subscriptionDetail.cycle++
            this.btnSubscriptionPlan.isSubmit = false
            this.btnSubscriptionPlan.isCancel = false
            this.btnSubscriptionPlan.isValid = false
            this.cycleErrorMessage = ''
        }
    }
}
</script>

<style lang="scss" scoped>
// ::v-deep .labelForm {
//     label {
//         font-size: 12px;
//     }
// }
::v-deep .el-row {
    margin-bottom: 0 !important;
}
::v-deep .divider-dash {
    border: 1px dashed #DCDFE6;
    background-color: transparent !important;
}
::v-deep .subscriptionDetail-radio {
    padding: 12px !important;
}
.account-summary {
    margin: 10px 0px 0px 40px;
    .acc-summary-title {
        color: #000000;
        font-size: 16px;
        font-weight: 500;
    }
    .acc-level-title {
        color: #000000;
        font-size: 16px;
        font-weight: 500;
    }
    ::v-deep .form-input {
        width: 100%;
        &.readonly {
            .el-input__inner {
                background-color: #f9fafc;
                color: #000000;
                opacity: 1 !important;
                border: 1px solid #DCDFE6;
            }
        }
        &.business-level-average {
            padding-right: 10px;
        }
        &.business-level-last {
            padding-left: 10px;
        }
        &.el-select {
            .el-input.is-disabled {
                .el-input__inner {
                    background-color: #f9fafc;
                    color: #000000;
                    opacity: 1 !important;
                    border: 1px solid #DCDFE6;
                }
            }
        }
    }
    .average-cycle {
        font-size: 12px;
        color: #606266;
    }
    .last-cycle {
        font-size: 12px;
        color: #606266;
        margin-left: 10px;
    }
    .subscription-plan {
        .label {
            width: 300px;
            margin-top: 10px;
        }
    }
    .subscription-plan-container {
        width: 100%;
        border-radius: 4px;
        background-color: #f9f9f9;
        margin-top: 20px;
        padding: 30px 10px 30px 30px;
        &.border {
            border: 1px solid #e40000;
        }
        .form-input {
            width: 90%;
        }
        ::v-deep .form-input-cycle {
            width: 45%;
            .el-input__inner {
                text-align: center;
            }
        }
        .btn-minus {
            margin-right: 10px;
            background-color: #000000;
            border-color: #000000;
        }
        .btn-plus {
            margin-left: 10px;
            background-color: #000000;
            border-color: #000000;
        }
    }
    .edit-annual-valid-message {
        color: #e40000;
        font-size: 12px;
    }
}
</style>
